const sectionKinds = {
    数据支撑: 'data',
    今日判断: 'judgement',
    采购与供货: 'action',
    采购建议: 'action',
    供货与调拨: 'action',
    积压与优化: 'action',
    观察与核查: 'action',
    判断边界: 'note',
    报告口径: 'note',
}

export function nodeText(node) {
    return node.value || (node.children || []).map(nodeText).join('')
}

function formatActionField(item) {
    const first = item.children && item.children[0]
    const text = first && first.type === 'paragraph' && first.children[0]
    if (!text || text.type !== 'text') return item
    const match = text.value.match(/^(适用仓库|依据|建议负责|建议|条件)([：:]\s*|$)/)
    if (!match) return item
    const remainder = text.value.slice(match[0].length)
    const children = item.children.slice(1)
    if (remainder || first.children.length > 1) {
        children.unshift({ ...first, children: [{ ...text, value: remainder }, ...first.children.slice(1)] })
    }
    // 仅把标签与内容分栏，保留原文、标点和嵌套列表，不提取或重算业务数据。
    return { ...item, type: 'reportField', label: match[0], field: match[1], children }
}

function groupBlocks(section) {
    const children = []
    let block
    section.children.slice(1).forEach((node) => {
        if (node.type === 'heading' && node.depth === 3) {
            block = { type: 'reportBlock', title: nodeText(node), kind: section.kind, children: [node] }
            children.push(block)
        } else if (block) {
            block.children.push(node)
        } else {
            children.push(node)
        }
    })
    children.forEach((node) => {
        if (node.type !== 'reportBlock') return
        if (section.kind === 'data' && node.title === '重点建议的量化依据') {
            node.type = 'reportEvidence'
            node.count = node.children.filter((child) => child.type === 'list').reduce((sum, list) => sum + list.children.length, 0)
        }
        if (section.kind === 'action') {
            node.children = node.children.map((child) => (child.type === 'list' ? { ...child, children: child.children.map(formatActionField) } : child))
        }
    })
    section.children = [section.children[0], ...children]
    section.empty = children.length === 0
}

// 按 Markdown 语法树组织章节，代码块中的 #、引用与表格都不会被误切成标题。
export default function organizeReport(tree) {
    const children = []
    let section
    let index = 0
    tree.children.forEach((node) => {
        if (node.type === 'heading' && node.depth === 2) {
            const title = nodeText(node)
            section = {
                type: 'reportSection',
                id: `inventory-chapter-${++index}`,
                number: index,
                title,
                kind: sectionKinds[title] || 'normal',
                children: [node],
            }
            children.push(section)
        } else if (section) {
            section.children.push(node)
        } else {
            children.push(node)
        }
    })
    children.filter((node) => node.type === 'reportSection').forEach(groupBlocks)
    return { ...tree, children }
}
